export function isLetter(char) {
  return char.match(/[a-z]/i)
}
